import { Table, Tooltip } from 'antd';
import AntdTable from 'components/AntdTable';
import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import useModalConfirm from 'hook/useModalConfirm';
import { TooltipHide } from 'page/Application/ManageCompanyList/CompanyList/styled';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import useMultiLanguageEnterpriseLog from '../hook/useMultiLanguageAccountLog';

const FileDownloadRankingTable = ({ dataRaw, isLoading, emptyText }) => {
  const navigate = useNavigate();

  const {
    ACCOUNT_LOG_TABLE_ID,
    FILE_DOWNLOAD_RANKING_TABLE_URL,
    FILE_DOWNLOAD_RANKING_TABLE_DETAIL_TITLE,
    FILE_DOWNLOAD_RANKING_TABLE_PRODUCT_NAME,
    FILE_DOWNLOAD_RANKING_TABLE_COUNT,
  } = useMultiLanguageEnterpriseLog();

  const { contextHolder } = useModalConfirm();
  const { isOnline, errorNetWork, contextErrorNetWork } =
    useErrorNetworkMessage();

  const columns = useMemo(() => {
    return [
      Table.SELECTION_COLUMN,
      {
        key: 'id',
        title: (
          <TooltipHide>
            <Tooltip title={ACCOUNT_LOG_TABLE_ID} placement={'topLeft'}>
              {ACCOUNT_LOG_TABLE_ID}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'id',
        align: 'left',
        width: 120,
        render: (id) => (
          <TooltipHide>
            <Tooltip title={id} placement={'topLeft'}>
              {id}
            </Tooltip>
          </TooltipHide>
        ),
      },
      {
        key: 'url',
        title: (
          <TooltipHide>
            <Tooltip
              title={FILE_DOWNLOAD_RANKING_TABLE_URL}
              placement={'topLeft'}
            >
              {FILE_DOWNLOAD_RANKING_TABLE_URL}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'url',
        align: 'left',
        ellipsis: true,
        render: (url) => (
          <TooltipHide>
            <Tooltip title={url} placement={'topLeft'}>
              {url}
            </Tooltip>
          </TooltipHide>
        ),
      },
      {
        key: 'detailTitle',
        title: (
          <TooltipHide>
            <Tooltip
              title={FILE_DOWNLOAD_RANKING_TABLE_DETAIL_TITLE}
              placement={'topLeft'}
            >
              {FILE_DOWNLOAD_RANKING_TABLE_DETAIL_TITLE}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'detailTitle',
        align: 'left',
        ellipsis: true,
        render: (detailTitle) => (
          <TooltipHide>
            <Tooltip title={detailTitle} placement={'topLeft'}>
              {detailTitle}
            </Tooltip>
          </TooltipHide>
        ),
      },
      {
        key: 'productName',
        title: (
          <TooltipHide>
            <Tooltip
              title={FILE_DOWNLOAD_RANKING_TABLE_PRODUCT_NAME}
              placement={'topLeft'}
            >
              {FILE_DOWNLOAD_RANKING_TABLE_PRODUCT_NAME}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'productName',
        align: 'left',
        ellipsis: true,
        render: (productName) => (
          <TooltipHide>
            <Tooltip title={productName} placement={'topLeft'}>
              {productName}
            </Tooltip>
          </TooltipHide>
        ),
      },
      {
        key: 'count',
        title: (
          <TooltipHide>
            <Tooltip
              title={FILE_DOWNLOAD_RANKING_TABLE_COUNT}
              placement={'topLeft'}
            >
              {FILE_DOWNLOAD_RANKING_TABLE_COUNT}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'count',
        align: 'left',
        width: 90,
        render: (count) => (
          <TooltipHide>
            <Tooltip title={count?.toLocaleString()} placement={'topLeft'}>
              {count?.toLocaleString()}
            </Tooltip>
          </TooltipHide>
        ),
      },
    ];
  }, [navigate, isOnline, errorNetWork]);

  // format data for render table
  const dataSource = useMemo(() => {
    if (isLoading && !dataRaw) return [];
    return dataRaw?.list?.map((item) => ({
      ...item,
      key: item.id,
    }));
  }, [dataRaw, isLoading]);

  return (
    <>
      {contextHolder}
      {contextErrorNetWork}
      <AntdTable
        columns={columns}
        isLoading={isLoading}
        dataSource={dataSource}
        emptyText={emptyText}
      />
    </>
  );
};

export default FileDownloadRankingTable;
